/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApollonCopySettings } from '../../models/apollon-copy-settings';

export interface ConnectorCopyPublicItemsFiles$Params {
      body?: ApollonCopySettings
}

export function connectorCopyPublicItemsFiles(http: HttpClient, rootUrl: string, params?: ConnectorCopyPublicItemsFiles$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<{
'id'?: string;
'message'?: string;
}>>> {
  const rb = new RequestBuilder(rootUrl, connectorCopyPublicItemsFiles.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<{
      'id'?: string;
      'message'?: string;
      }>>;
    })
  );
}

connectorCopyPublicItemsFiles.PATH = '/apollon-connector/items/files/copy';
